import { inject } from '@angular/core';
import { DialogService } from '@core/services';
import { BaseComponent } from '@shared/classes';
import { VisitInfoModalComponent } from '@shared/components/modals/visit-info-modal/visit-info-modal.component';
import { CampaignPhase } from '@shared/constants';
import { FrequencyChallenge } from '@shared/factory';

export class FrequencyBaseClass extends BaseComponent {
  private readonly dialog: DialogService = inject(DialogService);

  displayInfoDialog(phase: CampaignPhase, challenge: FrequencyChallenge): void {
    if (phase !== CampaignPhase.CURRENT) {
      return;
    }
    this.dialog.open(VisitInfoModalComponent, {
      data: challenge,
    });
  }
}
